module.exports = __webpack_public_path__ + "img/keepers.1ce97df6.svg";